import React from "react";
import { Card, Button } from "antd";
import { FaCalendarAlt } from "react-icons/fa";
import BirthdayDetails from "views/console/team-managements/components/BirthdayDetails";
import HolidayDetails from "views/console/team-managements/components/HolidayDetails";

const ProfileCard = (props) => {

  const { name, location, role, date, type, color } = props;
  return (


    <Card className={`rounded-2xl border-2 border-slate-300 hover:shadow-md mt-2 ${
      type === "Birthdays"
      ? "hover:border-purple-200"
      : "hover:border-emerald-200"
    }`}>
      
      {type === "Birthdays" ?
        <BirthdayDetails
        {...props}/>

      : 
        <HolidayDetails
        {...props}/>

      }
    </Card>
  );
};

export default ProfileCard;

